export default __webpack_public_path__ + "static/media/no_img_research.568b9bc1.png";